/**
 * How close a directory's SAML signing certificate is to expiring. When it
 * expires, the directory's sign-ins stop — and nobody is told: the Hapsout
 * Google organisation's certificate once lapsed in silence. Both the directory
 * page and the tenant sheet read it from here, so they agree on the threshold.
 */

/** At or under this many days left, the expiry is a warning. */
export const SIGNING_CERTIFICATE_WARNING_DAYS = 60;

const DAY_MS = 24 * 60 * 60 * 1000;

export type SigningCertificateExpiry =
  | { state: "unknown" }
  | { state: "ok" | "soon"; expiresAt: number; daysLeft: number }
  | { state: "expired"; expiresAt: number };

export function signingCertificateExpiry(
  expiresAt: number | null | undefined,
  now: number = Date.now(),
): SigningCertificateExpiry {
  if (typeof expiresAt !== "number" || !Number.isFinite(expiresAt) || expiresAt <= 0) return { state: "unknown" };
  if (expiresAt <= now) return { state: "expired", expiresAt };
  const daysLeft = Math.ceil((expiresAt - now) / DAY_MS);
  return { state: daysLeft <= SIGNING_CERTIFICATE_WARNING_DAYS ? "soon" : "ok", expiresAt, daysLeft };
}

/** `in 1 day`, `in 12 days`. */
export function inDays(days: number): string {
  return `in ${days} ${days === 1 ? "day" : "days"}`;
}
